import { useState } from "react";
import { motion } from "framer-motion";
import { RotateCcw, UserRound, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { useUser } from "../context/UserContext";
import { resetActiveSession } from "../lib/api";
import SoundToggle from "../components/SoundToggle";
import PageWrapper from "./PageWrapper";

export default function SettingsView() {
  const { currentUser, currentUserId, switchUser } = useUser();
  const navigate = useNavigate();
  const [resetting, setResetting] = useState(false);
  const canResetSession = currentUserId === "user-1";

  const resetSession = async () => {
    if (!canResetSession || resetting) return;
    const confirmed = window.confirm(
      "Réinitialiser la partie en cours ?\n\nLes réponses, affinités et éventuelles photos de cette session seront supprimées pour vous deux. Les comptes, PIN et profils seront conservés."
    );
    if (!confirmed) return;

    setResetting(true);
    try {
      await resetActiveSession(currentUserId);
      toast.success("Nouvelle partie créée");
      navigate("/cards", { replace: true });
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Impossible de réinitialiser la partie");
    } finally {
      setResetting(false);
    }
  };

  return (
    <PageWrapper>
      <div className="settings-view" data-testid="settings-view">
        <p className="page-eyebrow">Vous</p>
        <h1 className="page-title">Réglages</h1>

        <div className="settings-card">
          <div className="settings-row">
            <span className="settings-row-left">
              <UserRound size={20} strokeWidth={1.5} />
              <span>Pseudonyme</span>
            </span>
            <span className="settings-value" data-testid="current-pseudonym">
              {currentUser?.pseudonym}
            </span>
          </div>

          <SoundToggle />

          <motion.button
            className="switch-user-btn"
            data-testid="switch-user-btn"
            whileTap={{ scale: 0.97 }}
            onClick={switchUser}
          >
            <RefreshCw size={18} strokeWidth={1.5} />
            Changer d'utilisateur
          </motion.button>
        </div>

        {canResetSession && (
          <div
            className="settings-card"
            style={{ marginTop: 16, borderColor: "rgba(238, 130, 165, 0.18)" }}
          >
            <div style={{ padding: "2px 0 12px" }}>
              <strong style={{ display: "block", fontSize: "0.92rem", marginBottom: 5 }}>
                Partie en cours
              </strong>
              <span style={{ display: "block", opacity: 0.68, fontSize: "0.78rem", lineHeight: 1.45 }}>
                Repars de zéro avec 20 nouvelles cartes sans supprimer les comptes, PIN ou profils.
              </span>
            </div>

            <motion.button
              className="switch-user-btn"
              data-testid="reset-session-btn"
              whileTap={{ scale: 0.97 }}
              onClick={resetSession}
              disabled={resetting}
              style={{ borderColor: "rgba(239, 128, 163, 0.28)" }}
            >
              <RotateCcw size={18} strokeWidth={1.5} />
              {resetting ? "Réinitialisation…" : "Réinitialiser la partie"}
            </motion.button>
          </div>
        )}

        <p className="settings-foot">Une expérience privée, pour deux.</p>
      </div>
    </PageWrapper>
  );
}
